module.exports = __webpack_public_path__ + "static/curem-4b0dd58fcb8d0bfb643277134de38a09.mp4";